import { useDispatch } from 'react-redux';
import { restore as restoreSeatsIO } from './seats-io/seats-io.slice';
import { restore as restoreAuth } from './auth/auth.slice';
import { restore as restoreSurveys } from './surveys/surveys.slice';
import { restore as restoreSummary } from './summary/summary.slice';
import { restore as restoreCheckout } from './checkout/checkout.slice';
import { restore as restorePromotions } from './promotions/promotions.slice';
import { restore as restoreMsi } from './msi/msi.slice';
import { restore as restoreRsvp } from './rsvp/rsvp.slice';
import { restoreTicketInsurance, retore } from './addons/addons.slice';
import { restore as restorePaths } from './stepper/stepper.slice';
import { restore as restoreCustomLinks } from './custom-links/customLinks.slice.js';
import { restore as restoreBillboardId } from './billboard/billboard.slice.js';
import { restore as restoreMsci } from './msci/msci.slice';
import { restore as restoreEmbedded } from './embedded/embedded.slice';
import { restore as restoreExchange } from './exchange/exchange.slice';
import { restore as restoreTimer } from './timer/timer.slice';
import { restore as restorePayment } from './payment/payment.slice';

export default function useResetStore() {
  const dispatch = useDispatch();
  const restore = () => {
    dispatch(restoreAuth());
    dispatch(restoreSurveys());
    dispatch(restoreSeatsIO());
    dispatch(restoreSummary());
    dispatch(restoreCheckout());
    dispatch(restorePromotions());
    dispatch(restoreMsi());
    dispatch(restoreRsvp());
    dispatch(restorePaths());
    dispatch(restoreTicketInsurance());
    dispatch(retore());
    dispatch(restoreCustomLinks());
    dispatch(restoreBillboardId());
    dispatch(restoreMsci());
    dispatch(restoreEmbedded());
    dispatch(restoreExchange());
    dispatch(restoreTimer());
    dispatch(restorePayment());
  };

  return {
    restore,
  };
}
